import type { RouteLocationAsRelative, RouteRecordRaw } from 'vue-router'

import { ME_ACTIVITY_FACETS_ROUTE } from '~/contexts/me/router/router-activity'
import { ME_CONTRIBUTIONS_FACETS_ROUTE } from '~/contexts/me/router/router-contributions'
import { ME_DRAFTS_FACETS_ROUTE } from '~/contexts/me/router/router-drafts'
import {
  ME_PERSONAL_SPACE_FACETS_ROUTE,
  ME_PERSONAL_SPACE_SETTINGS_ROUTE,
} from '~/contexts/me/router/router-personal-space'
import { ME_PROFILE_ROUTE } from '~/contexts/me/router/router-profile'
import { ROUTE_ME } from '~/contexts/me/router/routes'

import { useLastVisitedMyUniverse } from '~/features-shared/me/stores/states'

const ME_SECURITY_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.SECURITY,
  path: 'security',
  component: () => import('~/contexts/me/pages/security.vue'),
  meta: { name: 'me-security' },
}

const ME_REQUESTS_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.REQUESTS,
  path: 'requests',
  component: () => import('~/contexts/me/pages/requests.vue'),
  meta: { name: 'me-requests' },
}

const ME_RECYCLE_BIN_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.RECYCLE_BIN,
  path: 'recycle-bin',
  component: () => import('~/contexts/me/pages/recycle-bin.vue'),
  meta: { name: 'me-recycle-bin' },
}

const ME_PREFERENCES_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PREFERENCES,
  path: 'preferences',
  component: () => import('~/contexts/me/pages/preferences.vue'),
  meta: { name: 'me-preferences' },
}

const ME_ORGANIZATION_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.ORGANIZATION,
  path: 'organization',
  component: () => import('~/contexts/me/pages/organization.vue'),
  meta: { name: 'me-organization' },
}

const ME_BOOKMARKS_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.BOOKMARKS,
  path: 'bookmarks',
  component: () => import('~/contexts/me/pages/bookmarks.vue'),
  meta: { name: 'me-bookmarks' },
}

const ME_HOME_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.HOME,
  path: '',
  beforeEnter(_to, _from, next) {
    const lastVisitedMyUniverse = useLastVisitedMyUniverse()
    if (lastVisitedMyUniverse.value)
      return next({ name: lastVisitedMyUniverse.value!, replace: true } as RouteLocationAsRelative)

    else
      return next({ name: ROUTE_ME.CONTRIBUTIONS_HOME, replace: true })
  },
  component: () => ({}),
  meta: { name: 'me' },
}

/** Register all community routes as child of "/community" namespace */
export function getRoutes() {
  return [
    ME_HOME_ROUTE,

    ME_ACTIVITY_FACETS_ROUTE,
    ME_CONTRIBUTIONS_FACETS_ROUTE,
    ME_DRAFTS_FACETS_ROUTE,
    ME_PERSONAL_SPACE_FACETS_ROUTE,
    ME_PERSONAL_SPACE_SETTINGS_ROUTE,
    ME_PROFILE_ROUTE,

    ME_SECURITY_ROUTE,
    ME_REQUESTS_ROUTE,
    ME_RECYCLE_BIN_ROUTE,
    ME_PREFERENCES_ROUTE,
    ME_ORGANIZATION_ROUTE,
    ME_BOOKMARKS_ROUTE,
  ]
}
